/**
 * Created by lg on 18/5/22.
 */
import Vue from 'vue';
import { PopStatus, OperationConstant } from './Constants';

/**
 * 默认内容居中显示
 * 改为靠左显示
 * @return {{style: string}}
 */
const getClass = () => ({ style: 'text-align: left; word-break: break-all' });

const PopHelper = {};
// type用来区分是list页面还是详情页面，用于操作成功之后的刷新。
export function ops(caseOps, target, params, type, disabled) {
	if (type === 'detail' && disabled) {
		return;
	}
	switch (parseInt(caseOps, 10)) {
		case PopStatus.TURN_ON:
			Pop.open_cps(target, params, type);
			break;
		case PopStatus.TURN_OFF:
			Pop.close_cps(target, params, type);
			break;
		case PopStatus.RESTART:
			Pop.reset_cps(target, params, type);
			break;
		case PopStatus.RESET_PASSWORD:
			Pop.resetPassword(target, params);
			break;
		case PopStatus.SOS:
			target.sosShow = true;
			break;
		case PopStatus.RESETSOS:
			target.resetSOSShow = true;
			break;
		case PopStatus.FIXSOS:
			target.fixSOSShow = true;
			break;
		case PopStatus.REINSTALL:
			Ajax.get({
				action: '/getInstanceInfo',
				param: {
					region: params.region,
					instanceId: params.instanceId,
					az: params.az,
				},
				success: (data) => {
					data = data.instance;
					target.sys_rein_gridData = [];
					target.sys_rein_form.mirror = data.osName;
					target.sys_rein_gridData.push({
						name: data.name,
						system: data.systemDiskDesc,
						expire_date: data.charge.chargeExpiredTime,
						charge: target.chargeModeMap[data.charge.chargeMode],
						server_data: data,
					});
					target.sys_rein_dialog_visible = true;
					target.getAvailableOs();
				}
			});
			break;
		case PopStatus.BANDWIDTH:
			Ajax.get({
				action: '/getInstanceInfo',
				param: {
					region: params.region,
					instanceId: params.instanceId,
					az: params.az,
				},
				success: (data) => {
					target.public_net_gridData = [];
					target.public_net_gridData.push({
						name: params.name,
						public_ip: params.publicIp,
						public_ipv6: params.publicIpv6,
						expire_date: params.charge.chargeExpiredTime,
						current_bandwidth: `${data.instance.bandwidth}Mbps`,
						charge: params.chargeDesc,
						server_data: params,
						enableIpv6: params.enableIpv6
					});
					target.public_net_dialog_visible = true;
					target.minBandwidth = data.instance.bandwidth;
				}
			});
			break;
		case PopStatus.RENEW:
			Ajax.get({
				url: '/api/order',
				action: '/submitRenew',
				param: {
					region: params.region,
					resourceId: params.instanceId,
				},
				success: (data) => {
					if (type !== 'detail') {
						target.updateList('refresh');
					}

					window.location.href = `${Vue.prototype.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${data.tmpOrderId}&resourceType=cps`;
				},
			});
			break;
		case PopStatus.EDIT_TAG:
			target.currentRow = params;
			target.editTagDialogVisible = true;
			break;
		case PopStatus.DELETE:
			target.currentRow = params;
			target.deleteVisible = true;
			break;
		case PopStatus.turnOnDeleteProtect:
			target.currentRow = params;
			target.enableDeletionProtectionVisible = true;
			break;
		case PopStatus.turnOffDeleteProtect:
			target.currentRow = params;
			target.disableDeletionProtectionVisible = true;
			break;
		default:
			break;
	}
}

// 开机
export function open_cps(target, params, type) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.title.open'),
		message: h('p', getClass(), [
			h('span', null, target.$t('popHelper.speechCraft.sureOpen', [params.name])),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then(() => {
		const param = {
			instanceId: params.instanceId,
			region: params.region,
			clientToken: target.clientToken
		}
		Ajax.put('/api/cps/startInstance',param)
		.then(()=>{
			if (type === 'list') {
				target.updateList('refresh');
			} else if (type === 'detail') {
				target.refreshData();
			}
		});
		
	}).catch(() => {

	});
}

// vpc instance open
export function vpcInstance_open(target, params, type) { // eslint-disable-line
	const h = target.$createElement;
	target.$msgbox({
		title: target.$t('popHelper.title.open'),
		message: h('p', getClass(), [
			h('span', null, target.$t('popHelper.speechCraft.sureOpen', [params.name])),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then(() => {
		const openParams = {
			instanceId: params.instanceId,
			region: params.region,
			clientToken: Normal.getClientToken(),
		};
		Ajax.put('/api/cps/startInstance', openParams)
			.then()
			.finally(() => {
				console.log('test--vpc--open');
				console.log(params, 'test-params');
				if (type === 'list') {
					target.refreshList({});
					console.log('list');
				} else if (type === 'detail') {
					target.operateRefresh();
					console.log('detail');
				}
			});
	});
}

// 关机
export function close_cps(target, params, type) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.title.close'),
		message: h('p', getClass(), [
			h('span', null, target.$t('popHelper.speechCraft.sureClose', [params.name])),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	})
	.then(() => {
		target.openOperationProtect(OperationConstant.STOP, params, type)
	})
	.catch(() => {});
}

// 重启
export function reset_cps(target, params, type) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.title.restart'),
		message: h('p', getClass(), [
			h('span', null, target.$t('popHelper.speechCraft.sureRestart', [params.name])),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	})
		.then(() => {
			target.openOperationProtect(OperationConstant.RESTART, params, type)
		})
		.catch(() => {

		});
}

// vpc instance close
export function vpcInstance_close(target, params, type) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.title.close'),
		message: h('p', getClass(), [
			h('span', null, target.$t('popHelper.speechCraft.sureClose', [params.name])),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then(() => {
		target.openOperationProtect(OperationConstant.STOP, params, type)
	});
}

// vpc instance reboot
export function vpcInstace_restart(target, params, type) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.title.restart'),
		message: h('p', getClass(), [
			h('span', null, target.$t('popHelper.speechCraft.sureRestart', [params.name])),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then(() => {
		target.openOperationProtect(OperationConstant.RESTART, params, type)

		// const restartParams = {
		//   instanceId: params.instanceId,
		//   region: params.region,
		//   clientToken: Normal.getClientToken(),
		// };
		// Ajax.put('/api/cps/restartInstance', restartParams)
		//   .then()
		//   .finally(() => {
		//     if (type === 'list') {
		//       target.refreshList({});
		//       console.log('list');
		//     } else if (type === 'detail') {
		//       target.operateRefresh();
		//       console.log('detail');
		//     }
		//   });
	});
}

// 重置密码
export function resetPassword(target, params) {
	target.resetPasswordDialogVisible = true;
	target.currentRow = params
	console.log(params)
}

// vpc instance unbind
export function vpcInstance_unbind(target, params, type) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('privateNetInstance.unBindTitle'),
		message: h('p', getClass(), [
			h('span', null, target.$t('privateNetInstance.sureUnBindTip', [params.publicIp])),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then(() => {
		const unbindParams = {
			region: params.region,
			instanceId: params.instanceId,
			elasticIpId: params.elasticIpId
		};
		Ajax.put('/api/cps/disassociateElasticIp', unbindParams)
			.then(() => {
				// target.$message.success(target.$t('privateNetInstance.operateSuccess'));
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					target.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			}).finally(() => {
				if (type === 'list') {
					target.refreshList({});
					console.log('list');
				} else if (type === 'detail') {
					target.operateRefresh();
					console.log('detail');
				}
			});
	});
}

// 私有网络删除
export function del_private_net(target, params, type) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('privateNetwork.delTitle'),
		message: h('p', getClass(), [
			h('span', null, target.$t('privateNetwork.delConfirm', [params.name])),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then(() => {
		const delParams = {
			region: params.region,
			vpcId: params.vpcId
		};
		Ajax.del('/api/cps/vpcs', delParams)
			.then((res) => {
				// TODO with tip
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					target.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				if (type === 'list') {
					target.refreshList({});
				} else if (type === 'detail') {
					// target.getPrivateNetDetail(delParams);
					target.$router.push({
						path: '/vpc/list',
						query: {
							region: params.region
						}
					});
				}
			});
	});
}

// 库存不足
export function stock_low(target) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.speechCraft.stockNotEnough'),
		message: h('p', getClass(), [
			h('span', { style: 'fontSize: 20px' }, target.$t('popHelper.speechCraft.stockNotEnoughWaring[0]')),
			h('p', null, ''), h('p', null, ''),
			h('span', null, target.$t('popHelper.speechCraft.stockNotEnoughWaring[1]')),
			h('p', null, ''), h('p', null, ''),
			h('span', null, target.$t('popHelper.speechCraft.stockNotEnoughWaring[2]')),
			h('span', { style: 'color: blue' }, '400-615-1212 （7*24）'),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.submitSheet'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then((action) => {
		Normal.goWorkPage();
	}).catch(() => {

	});
}

// 用户Quota
export function fail_quota(target) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.speechCraft.userQuota[0]'),
		message: h('p', getClass(), [
			h('span', { style: 'fontSize: 20px' }, target.$t('popHelper.speechCraft.userQuota[1]')),
		])
	}).then((action) => {
	}).catch(() => {
	});
}


// 个人用户不允许购买
export function personal_buy(target) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.speechCraft.personalUser[0]'),
		message: h('p', getClass(), [
			h('span', null, target.$t('popHelper.speechCraft.personalUser[1]')),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then((action) => {
	}).catch(() => {
	});
}

// 活动1台
export function only_one(target) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.speechCraft.onlyOne[0]'),
		message: h('p', getClass(), [
			h('span', null, target.$t('popHelper.speechCraft.onlyOne[1]')),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then((action) => {
		Normal.goListPage();
	}).catch(() => {
	});
}

// 未支付订单
export function repeat_order(target) { // eslint-disable-line
	const h = target.$createElement;

	target.$msgbox({
		title: target.$t('popHelper.speechCraft.unpaidOrder[0]'),
		message: h('p', getClass(), [
			h('span', null, target.$t('popHelper.speechCraft.unpaidOrder[1]')),
		]),
		closeOnClickModal: false,
		showCancelButton: true,
		confirmButtonText: target.$t('popHelper.text.sure'),
		cancelButtonText: target.$t('popHelper.text.cancel'),
	}).then((action) => {
		Normal.goOrderPage();
	}).catch(() => {
	});
}

export default PopHelper;



// WEBPACK FOOTER //
// ./src/common/PopHelper.js